import { render, staticRenderFns } from "./PredicateList.vue?vue&type=template&id=46dc69c5"
import script from "./PredicateList.vue?vue&type=script&lang=js"
export * from "./PredicateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports